// Nested campaigns always count as large: they trigger async loads and saves.
const LARGE_NODE_COUNT = 8;

const hasNestedCampaigns = (items) =>
  Array.isArray(items) && items.some((task) => task && task.nestedSprintId);

/** Copy/paste/duplicate big enough to show the blocking busy overlay. */
export function isLargeOperation(items) {
  return hasNestedCampaigns(items) || (Array.isArray(items) && items.length >= LARGE_NODE_COUNT);
}
